import FirewallTemplate from 'components/firewall/FirewallTemplate';
import GlobalFirewall from 'components/firewall/GlobalFirewall';
import ObjectTemplate from 'components/firewall/ObjectTemplate';
import React from 'react';

const FireWall = ({ vsFirewall, refetch }) => {
  return (
    <div>
      <GlobalFirewall vsFirewall={vsFirewall} refetch={refetch} />
      <FirewallTemplate vsFirewall={vsFirewall} refetch={refetch} />
      <ObjectTemplate />
    </div>
  );
};

export default FireWall;
